/**
 * Quyền XEM CHI TIẾT ứng viên (mirror BE app/helper/profileAccessHelper.js):
 * admin(1/3) HOẶC mình phụ trách (assignee = mình / groupAssignee ∈ nhóm mình). Hồ sơ CHƯA gán -> cho xem.
 *
 * TRƯỞNG NHÓM (isLeader) KHÔNG bypass chi tiết ỨNG VIÊN (chốt 2026-07: leader thấy đủ LIST +
 * chi tiết HỒ SƠ XÉT TUYỂN để duyệt dùm, nhưng trang ứng viên đầy đủ chỉ khi mình phụ trách).
 *
 * Dùng để ẨN link mở chi tiết ngay trên list (đỡ bấm vào rồi bị chặn); BE vẫn là chốt thật (403).
 * user cũ trong localStorage CHƯA có isLeader (đăng nhập trước khi deploy) -> coi như non-leader,
 * link có thể bị ẩn nhầm với LEAD cho tới khi họ đăng nhập lại — chấp nhận (an toàn hướng chặt).
 */
// admin(1/3) hoặc role trưởng nhóm (user.isLeader từ payload login)
export function isLeaderOrAdmin(): boolean {
    let user: any = {};
    try {
        const temp = window.localStorage.getItem("user");
        user = temp ? JSON.parse(temp) : {};
    } catch (e) { user = {}; }
    return user?.role == 1 || user?.role == 3 || !!user?.isLeader;
}

/**
 * Lọc danh mục học bổng cho các dropdown CHỌN cấp/đăng ký: học bổng gắn cờ `leaderonly`
 * (scholarships.leaderonly — cấu hình ở Cài đặt TTNH > Học bổng) chỉ trưởng nhóm/admin thấy.
 * KHÔNG dùng cho bộ lọc XEM danh sách (vẫn cần lọc hồ sơ đã cấp học bổng đó).
 */
export function filterScholarshipOptions<T extends { leaderonly?: boolean }>(list: T[]): T[] {
    if (!Array.isArray(list)) return [];
    if (isLeaderOrAdmin()) return list;
    return list.filter((s) => !s.leaderonly);
}

export function canViewCandidateDetail(assignee?: any, groupAssignee?: any): boolean {
    let user: any = {};
    try {
        const temp = window.localStorage.getItem("user");
        user = temp ? JSON.parse(temp) : {};
    } catch (e) { user = {}; }

    if (user?.role == 1 || user?.role == 3) return true;
    // KHÔNG bypass isLeader: leader chỉ được duyệt qua list/drawer/modal, không mở trang ứng viên người khác
    if (!assignee && !groupAssignee) return true; // chưa gán phụ trách / list không có dữ liệu chủ hồ sơ -> để BE quyết
    if (assignee && String(assignee) === String(user?.id)) return true;
    const groups = Array.isArray(user?.usergroups) ? user.usergroups : [];
    if (groupAssignee && groups.some((g: any) => String(g.groupId) === String(groupAssignee))) return true;
    return false;
}
